import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import message from '~/utils/message';

const NavigateWithMessage = ({
  to,
  message: msg,
}: {
  to: string;
  message: { type: 'success' | 'error' | 'warning'; text: string };
}) => {
  useEffect(() => {
    let func = message.success;
    switch (msg.type) {
      case 'success':
        func = message.success;
        break;
      case 'error':
        func = message.error;
        break;
      case 'warning':
        func = message.warning;
        break;
    }
    func(msg.text);
  }, []);
  return <Navigate to={to} />;
};

export default NavigateWithMessage;
